/* La Vapumerie, parité mobile, lot 3, B01 : barre d'achat collante de 48 px sur les fiches, visible dès que le bouton d'ajout est sorti de l'écran.
   v76 (1er novembre 2026, AC-2026-0044) : avant le choix, « dès X € » prend le prix le plus bas de TOUTES les déclinaisons (lu une fois dans /products/<adresse>.js), et non le prix de la déclinaison ouverte par défaut ou par l'adresse ; le prix sous le titre de la fiche suit la même règle (v77 : le montant seul, le « dès » est déjà affiché par le thème).
   Remplace la barre basse sur les fiches (règle CSS vap-lot3). Lit l'état de vap-fiche.js (chargé avant) : prix, taux choisi, bouton grisé tant que le taux manque. */
(function () {
  "use strict";
  var F = window.vapFiche;
  if (!F) return;
  var info = F.info, visible = true, d = null, pv = false;
  var q = function (s, r) { return (r || document).querySelector(s); };
  var barre = document.createElement("div");
  barre.className = "vap-achat-collant"; barre.hidden = true; barre.setAttribute("role", "region"); barre.setAttribute("aria-label", "Achat");
  barre.innerHTML = '<div class="vac-info"><strong class="vac-prix"></strong><span class="vac-taux"></span></div><button type="button" class="vac-bouton"></button>';
  document.body.appendChild(barre);
  var bb = q(".vac-bouton", barre), minPrix = null, lu = false;
  function monnaie(c) { return (c / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €"; }
  function lireMin() {   /* une seule lecture par page, seulement quand le prix varie et que le client n'a pas choisi */
    if (lu) return; lu = true;
    fetch(location.pathname + ".js", { credentials: "same-origin" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      var v = p && p.variants ? p.variants : [], dispo = v.filter(function (x) { return x.available !== false; }), l = (dispo.length ? dispo : v).map(function (x) { return x.price; });
      if (l.length) { minPrix = Math.min.apply(null, l); synchroniser(); }
    }).catch(function () {});
  }
  function texte(el, t) { if (el.textContent !== t) el.textContent = t; }
  function poser(el, a, v) { if (v === null) { if (el.hasAttribute(a)) el.removeAttribute(a); } else if (el.getAttribute(a) !== v) el.setAttribute(a, v); }

  function synchroniser() {
    if (!d) return;
    var pr = q("[id^='price-'] .price", info), it = pr && q(pr.classList.contains("price--on-sale") ? ".price-item--sale" : ".price-item--regular", pr);
    var orig = it && it.getAttribute("data-vap-orig");
    var prix = it ? (orig || it.textContent.replace(/\s+/g, " ").trim()) : "", btn = q(".product-form__submit", info), epuise = !!(btn && btn.disabled);
    if (d.attente && pv) lireMin();
    var dess = d.attente && pv && prix ? "dès " + (minPrix !== null ? monnaie(minPrix) : prix) : null;
    if (it) {   /* le prix sous le titre suit la même règle : « dès » le plus bas avant le choix, puis le prix de la déclinaison choisie */
      if (dess && minPrix !== null) { if (!orig) it.setAttribute("data-vap-orig", prix); texte(it, monnaie(minPrix)); }   /* le « dès » sous le titre vient déjà du thème : on n'écrit que le montant */
      else if (orig && !(d.attente && pv)) { texte(it, orig); it.removeAttribute("data-vap-orig"); }
    }
    texte(q(".vac-prix", barre), dess || prix);
    texte(q(".vac-taux", barre), d.court);
    texte(bb, epuise ? q("span", btn).textContent.trim() : d.barre);
    poser(bb, "disabled", epuise ? "" : null); poser(bb, "aria-disabled", d.attente ? "true" : null);
    barre.hidden = visible || !prix;
  }
  bb.addEventListener("click", function () {
    var btn = q(".product-form__submit", info);
    if (d && d.attente) F.signaler(); else if (btn) btn.click();
  });
  var cible = q(".product-form__buttons", info);
  if (cible && "IntersectionObserver" in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; synchroniser(); }, { rootMargin: "-80px 0px -56px 0px" }).observe(cible);
  F.ecoute(function (etat, prixVarie) { d = etat; pv = prixVarie; synchroniser(); });
})();
